
import abi from "./contract/GlobalPool.json";

import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import jQuery from "jquery";


import "./logo.png";
import "./Global.gif";
import "./2.png";
import "./3.png";
import "./4.png";
import "./5.png";
import "./6.png";
import "./7.png";
import "./8.png";
import "./9.png";
import "./10.png";
import "./copy.png";


import { useState, useEffect } from "react";
import { ethers } from "ethers";

function App() {

  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  const [account, setAccount] = useState("None");
  
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
   const[l1,setl1]=useState("None");
  const[l2,setl2]=useState("None");
  const[l3,setl3]=useState("None");
  const[l4,setl4]=useState("None");
  const[l5,setl5]=useState("None");

  const[auto,setAuto]=useState("None");
  const[auto1,setAuto1]=useState("None");
  const[auto2,setAuto2]=useState("None");
  const[auto3,setAuto3]=useState("None");
  const[auto4,setAuto4]=useState("None");
  const[auto5,setAuto5]=useState("None");
  const[auto6,setAuto6]=useState("None");
  const [tasks1,setTasks1] = useState([]);
  const[auto7,setAuto7]=useState("None");
  const[bonus,setBonus]=useState("None");
  const[bonus1,setBonus1]=useState("None");
  const[pack,setpackage]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);

const [total,setTotal]=useState("None");
const [req,setreq]=useState("None");
const [tt,settt]=useState("None");
const[dd,setDD]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[bonanza1,setBonanza1]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
  const[nauto,setnAuto]=useState("None");
  const[nauto1,setnAuto1]=useState("None");
  const[nauto2,setnAuto2]=useState("None");
  const[nauto3,setnAuto3]=useState("None");
  const[nauto4,setnAuto4]=useState("None");
  const[nauto5,setnAuto5]=useState("None");
  const[nauto6,setnAuto6]=useState("None");
const[wid,setwid]=useState("None");


  useEffect(() => {
    const connectWallet = async () => {
      const contractAddress = "0xD48BB18cc3F17025CAe2B0F725fBB3647Be356c3";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
      const myParam = searchParams.get('ref');
      console.log(myParam);
      
      
      document.querySelector("#name").value=myParam;
  if(myParam == null)
  {
    document.querySelector("#name").value="0x6EB02DBdaa5F28ce7A971A710B57FB9eFeA3bF10";
  }
      try {
        const { ethereum } = window;
        document.querySelector("#test").value = "Upgrade USDT 50";
        if (ethereum) {
          const account = await ethereum.request({
            method: "eth_requestAccounts",
           
          });
         
          window.ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          window.ethereum.on("accountsChanged", () => {
            
            window.location.reload();
          });

          const provider = new ethers.providers.Web3Provider(ethereum);
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
          let alltasks = await contract.getMemos(account[0]);
          setTasks(alltasks);
           let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);
          const auto7 = Number(alltasks1)-1;
          setAuto7(auto7);
          const b =Number(alltasks[2]);
          const refer = (alltasks[1]);
         setrefer(refer);
         document.querySelector("#hid").value  = (alltasks[1]);
         const direct =Number(alltasks[2]);
         setDirect(direct);
         const directs =  Number(alltasks[22])/1000000000000000000;
         setDirects(directs);
         const level = Number(alltasks[23])/1000000000000000000;
         setLevel(level);
         const auto = Number(alltasks[11])/1000000000000000000;
         setAuto(auto);
         const auto1 = Number(alltasks[12])/1000000000000000000;
         setAuto1(auto1);
         const auto2 = Number(alltasks[13])/1000000000000000000;
         setAuto2(auto2);
         
         const auto3 = Number(alltasks[14])/1000000000000000000;
         setAuto3(auto3);
         
         const auto4 = Number(alltasks[15])/1000000000000000000;
         setAuto4(auto4);
         const auto5 = Number(alltasks[15])/1000000000000000000;
         setAuto5(auto5);
         const auto6 = Number(alltasks[16])/1000000000000000000;
         setAuto6(auto6);

         const b1 = (Number(alltasks[15])/1000000000000000000).toFixed(2);
       setb1(b1);
       const b2 = (Number(alltasks[24])/1000000000000000000).toFixed(2);
       setb2(b2);
       const b3 = (Number(alltasks[25])/1000000000000000000).toFixed(2);
       setb3(b3);
       const b4 = (Number(alltasks[26])/1000000000000000000).toFixed(2);
       setb4(b4);

         const nauto = Number(alltasks[14])/1000000000000000000;
         setnAuto(nauto);
         const nauto1 = Number(alltasks[15])/1000000000000000000;
         setnAuto1(nauto1);
         const nauto2 = Number(alltasks[24])/1000000000000000000;
         setnAuto2(nauto2);
         const nauto3 = Number(alltasks[25])/1000000000000000000;
         setnAuto3(nauto3);
         const nauto4 = Number(alltasks[26])/1000000000000000000;
         setnAuto4(nauto4);
         const nauto5 = Number(alltasks[27])/1000000000000000000;
         setnAuto5(nauto5);
         

         
          const l2 = Number(alltasks[33]);
         setl2(l2);
         const l3 = Number(alltasks[34]);
         setl3(l3);
         const l4 = Number(alltasks[35]);
         setl4(l4);
         const l5 = Number(alltasks[36]);
         setl5(l5);
         const l1 = Number(alltasks[32]);
         setl1(l1);
         
         
         
         const bonus = Number(alltasks[18]);
         setBonus(bonus);
         const bonus1 = Number(alltasks[19]);
         setBonus1(bonus1);
         const total = Number(alltasks[10]);
         setTotal(total);

         const tt = directs + level + bonus + auto + total + auto1 + auto2 + auto3 + auto4 + auto5 + auto6  + bonus1;
         settt(tt);
         
         const pack = Number(alltasks[6]);
         document.querySelector("#pp").value  = Number(alltasks[6]);
         
    
    setpackage(pack);
    const bonanza = Number(alltasks[7]);
         setBonanza(bonanza);
         const bonanza1 = Number(alltasks[20]);
         setBonanza1(bonanza1);
          
         
    const dd = new Date(alltasks[8].timestamp * 1000).toLocaleString();
    setDD(dd);
         setB(b);
         const referlink = 'https://backershub.live/?ref='+ account;
         setreflink(referlink);
         document.querySelector("#link").value =referlink;


    

         
    if(pack==50)
    { 
      document.querySelector("#test").value = "Upgrade USDT 100";
    
    }
    else if(pack==150)
    { 
      document.querySelector("#test").value = "Upgrade USDT 150";
    
    }
    else if(pack ==300)
    {
      document.querySelector("#test").value = "Upgrade USDT 250";
    }
    else if(pack ==550)
    {
      
      document.querySelector("#test").value = "Upgrade USDT 500";
    }
    else if(pack ==1050)
    {
      document.querySelector("#test").value = "Upgrade USDT 1000";
    }
    
    else if(pack ==2050)
    {
      document.querySelector("#test").value = "Upgrade USDT 2000";
    }
    else if(pack ==4050)
    {
      document.querySelector("#test").value = "Upgrade USDT 4000";
    }
     else if(pack ==8050)
    {
      document.querySelector("#test").value = "Upgrade USDT 8000";
    }
     else if(pack ==16050)
    {
      document.querySelector("#test").value = "Upgrade USDT 16000";
    }
     else if(pack ==32050)
    {
      document.querySelector("#test").value = "Upgrade USDT 32000";
    }
     else if(pack ==64050)
    {
      document.querySelector("#test").value = "Upgrade USDT 64000";
    }
     else if(pack ==128050)
    {
      document.querySelector("#test").value = "Upgrade USDT 128000";
    }
     else if(pack ==256050)
    {
      document.querySelector("#test").value = "Upgrade USDT 256000";
    }
     else if(pack ==512050)
    {
      document.querySelector("#test").value = "Upgrade USDT 512000";
    }
    else if(pack ==1024050)
    {
    
      document.querySelector("#test").value = "All Packages Purchased";
    }

    

else if(pack ==512050)
    {
    document.querySelector("#test").value = "All Packages Purchased";
    }

    console.log(pack);
   
     
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
     
    
    
    connectWallet();
    
  }, []);

 
  // console.log(state);
        
       
  return (
   
<div >
<input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    
    <section
  className="section-padding"
  id="income-stats"
  style={{ paddingTop: "40px", paddingBottom: "60px" }}
>
  <div className="container">
    <div className="section-header">
      <span className="eyebrow-tag">⚡ Live Community Growth</span>

      <h2 className="font-title">
        Dashboard Quick <span className="text-yellow">Stats & Incomes</span>
      </h2>

      <p>
        Real-time community telemetry, transparent reward distribution, and
        instant income tracking across the entire Backers Hub network.
      </p>
    </div>

    <div className="stats-dashboard-container">
     

      <div className="quick-stats-4grid">

        {/* BOX 1 */}
        <div className="income-stat-box">
          <div className="stat-icon-wrapper">
          🚀
          </div>

         

          <input
            type="text"
            id ="test"
            className="stat-box-input"
            
            placeholder="Enter amount..."
           
          />
            <input
           type ="hidden" id ="test1nn" 
            className="stat-box-input"
           
            placeholder="Enter amount..."
           
          />

         <Buy state={state} />
        </div>

     

      </div>
    </div>
  </div>
</section>


<section
  className="section-padding"
  id="team-stats-overview"
  style={{ paddingTop: "20px", paddingBottom: "60px" }}
>
  <div className="container">

    <div className="dashboard-dual-grid">
        {/* RIGHT PANEL */}
      <div className="panel-box">

        <div className="panel-header">
          <div className="panel-header-icon team-icon">👥</div>
          <h3>Joinings & Packages </h3> 
        </div>

        <div className="team-cards-2grid">

           

          <div className="team-block-card">
            <div className="team-block-val" id="qs-team-level">
              USDT {pack} 
            </div>
            <div className="team-block-sub">
             My Total Packages
            </div>
          </div>

        </div>
      </div>

      {/* LEFT PANEL */}
      <div className="panel-box">

        <div className="panel-header">
          <div className="panel-header-icon stats-icon">📊</div>
          <h3>Level Incomes</h3>
        </div>

        <div className="stats-list">

         

          <div className="stats-list-item">
            <span className="stats-item-label">level - I Income</span>
            <span className="stats-item-val" id="qs-invest2">
              USDT {auto}
            </span>
          </div>

          <div className="stats-list-item">
            <span className="stats-item-label">level - II Income</span>
            <span className="stats-item-val" id="qs-pending">
             USDT {auto1}
            </span>
          </div>

          <div className="stats-list-item">
            <span className="stats-item-label">Level - III Income</span>
            <span className="stats-item-val" id="qs-growth">
             USDT {auto2}
            </span>
          </div>

          <div className="stats-list-item">
            <span className="stats-item-label">Level - IV Income</span>
            <span className="stats-item-val" id="qs-direct">
            USDT {auto3}
            </span>
          </div>
           <div className="stats-list-item">
            <span className="stats-item-label">level - V Income</span>
            <span className="stats-item-val" id="qs-invest2">
             USDT {nauto}
            </span>
          </div>

          
        </div>
      </div>


      {/* RIGHT PANEL */}
      <div className="panel-box">

        <div className="panel-header">
          <div className="panel-header-icon team-icon">👥</div>
          <h3>Incomes</h3>
        </div>

        <div className="team-cards-2grid">

          <div className="team-block-card">
            <div className="team-block-val" id="qs-team-direct">
             USDT {directs}
            </div>
            <div className="team-block-sub">
            My Direct Income
            </div>
          </div>

          <div className="team-block-card">
            <div className="team-block-val" id="qs-team-level">
              USDT {level}
            </div>
            <div className="team-block-sub">
             Total Income
            </div>
          </div>
          
           <div className="team-block-card">
            <div className="team-block-val" id="qs-team-level">
             USDT {auto6}
            </div>
            <div className="team-block-sub">
             Single Leg Income
            </div>
          </div>
        </div>
        
      </div>

       <div className="panel-box">

        <div className="panel-header">
          <div className="panel-header-icon team-icon">👥</div>
          <h3>Royalty Club Income</h3>
        </div>

        <div className="team-cards-2grid">

          <div className="team-block-card">
            <div className="team-block-val" id="qs-team-direct">
             USDT {b1}
            </div>
            <div className="team-block-sub">
            VIP - I
            </div>
          </div>

          <div className="team-block-card">
            <div className="team-block-val" id="qs-team-level">
              USDT {b2}
            </div>
            <div className="team-block-sub">
             VIP - II
            </div>
          </div>
          
           <div className="team-block-card">
            <div className="team-block-val" id="qs-team-level">
             USDT {b3}
            </div>
            <div className="team-block-sub">
             VIP - III
            </div>
          </div>
          <div className="team-block-card">
            <div className="team-block-val" id="qs-team-level">
             USDT {b4}
            </div>
            <div className="team-block-sub">
             VIP - IV
            </div>
          </div>
        </div>
        
      </div>

        {/* RIGHT PANEL */}
      <div className="panel-box">

        <div className="panel-header">
          <div className="panel-header-icon team-icon">👥</div>
          <h3>Team Overview</h3>
        </div>

        <div className="team-cards-2grid">

          <div className="team-block-card">
            <div className="team-block-val" id="qs-team-direct">
            {direct}
            </div>
            <div className="team-block-sub">
          My Direct Team
            </div>
          </div>

        <div className="team-block-card">
            <div className="team-block-val" id="qs-team-direct">
            {bonus1}
            </div>
            <div className="team-block-sub">
         Level Team
            </div>
          </div>
       

        </div>
        
      </div>
       <div className="panel-box">

        <div className="panel-header">
          <div className="panel-header-icon stats-icon">📊</div>
          <h3>Level Team</h3>
        </div>

        <div className="stats-list">

          <div className="stats-list-item">
            <span className="stats-item-label">Direct Team</span>
            <span className="stats-item-val" id="qs-invest2">
               {direct}
            </span>
          </div>

          <div className="stats-list-item">
            <span className="stats-item-label">level - I Team</span>
            <span className="stats-item-val" id="qs-invest2">
               {l1}
            </span>
          </div>

          <div className="stats-list-item">
            <span className="stats-item-label">level - II Team</span>
            <span className="stats-item-val" id="qs-pending">
              {l2}
            </span>
          </div>

          <div className="stats-list-item">
            <span className="stats-item-label">Level - III Team</span>
            <span className="stats-item-val" id="qs-growth">
              {l3}
            </span>
          </div>

          <div className="stats-list-item">
            <span className="stats-item-label">Level - IV Team</span>
            <span className="stats-item-val" id="qs-direct">
             {l4}
            </span>
          </div>
           <div className="stats-list-item">
            <span className="stats-item-label">level - V Team</span>
            <span className="stats-item-val" id="qs-invest2">
              {l5}
            </span>
          </div>

          
        </div>
      </div>
    
<div className="panel-box">
  <div className="panel-header">
    <div className="panel-header-icon team-icon">🔗</div>
    <h3>My Refer :</h3>
  </div>

  <div className="team-cards-2grid">
    <div className="team-block-card" style={{ gridColumn: "1 / -1" }}>
      
      <div style={{wordBreak:"break-all"}} className="team-block-sub">
        {refer}
      </div>
    </div>
  </div>
</div>

<div className="panel-box">
  <div className="panel-header">
    <div className="panel-header-icon team-icon">📋</div>
    <h3>Refer Link</h3>
  </div>

  <div className="team-cards-2grid">
    <div  className="team-block-card" style={{ gridColumn: "1 / -1" ,wordBreak:"break-all"}}>
      {referlink}
       <button
  type="submit"
  id="sample"
  className="stat-box-btn"
  onClick={() => navigator.clipboard.writeText(referlink)}
>
              Copy ReferLink      
</button>
    
     

     
    </div>
  </div>
</div>
     
<div className="panel-box">
  <div className="panel-header">
    <div className="panel-header-icon team-icon">👤</div>
    <h3>Welcome To Backers Hub :</h3>
  </div>

  <div className="team-cards-2grid">
    <div className="team-block-card" style={{ gridColumn: "1 / -1" }}>
     <h4>Connected Account:</h4>
      <div style={{wordBreak:"break-all"}} className="team-block-sub">
        {account}
      </div>
    </div>
  </div>
</div>



    
    </div>

  </div>
</section>

    
                       
    </div>                      
  
  );
}

export default App;
